// Mutations
export const SET_PAGES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.pages.data = payload
    state.pages.lastUpdate = new Date()
  }
}
export const SET_PAGES_LOADING = (state, payload) => {
  state.pages.loading = payload
}

export const SET_PAGE_CONTENT = (state, { id, value }) => {
  state.pageContent.data[id] = value
  state.pageContent.lastUpdate = new Date()
}
export const SET_PAGE_CONTENT_LOADING = (state, { id, value }) => {
  state.pageContent.loading[id] = value
}

export const SET_FILTERS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    const oldData = state.filters.data.reduce((all, next) => {
      all[next.options.title] = next.data
      return all
    }, {})
    state.filters.filtersValues = {
      ...state.filters.filtersValues,
      ...oldData,
    }
    state.filters.data = payload.map((filter) => {
      if (!filter || !filter.options) {
        console.error('Filtro não identificado', filter)
        return
      }
      const value =
        state.filters.filtersValues[filter.options.title] ||
        filter.data ||
        filter.options.default
      let data = value
      if (
        filter.options.multiple &&
        (typeof value === 'string' || !Array.isArray(value))
      ) {
        data = [value]
      } else if (!filter.options.multiple && Array.isArray(value)) {
        data = value[0] || filter.options.default || null
      }

      return {
        ...filter,
        data,
      }
    })
  } else {
    state.filters.data = []
  }

  // state.filters.data = payload || []
}
export const UPDATE_FILTER = (state, payload) => {
  const { key, value, title } = payload

  const oldItem = state.filters.data.find((item) => {
    const sameKey = item.options.key === key
    const sameTitle = item.options.title === title

    if (key && title) return sameKey && sameTitle
    if (key) return sameKey
    if (title) return sameTitle

    return false
  })

  if (oldItem) {
    oldItem.data = value
  }
}
export const RESET_FILTERS = (state, payload) => {
  state.filters.data = payload || []
}
export const SET_ANALYSIS_BI = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.analysisBi.data = payload
    state.analysisBi.lastUpdate = new Date()
  }
}
export const ADD_ANALYSIS_BI = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.analysisBi.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.analysisBi.data.push(data)
      }
    })
  }
}
export const SET_ANALYSIS_BI_LOADING = (state, payload) => {
  state.analysisBi.loading = payload
}

export const SET_MODELO_SERVIR_OVERVIEW = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.modeloServirOverview.data = payload
    state.modeloServirOverview.lastUpdate = new Date()
  }
}
export const ADD_MODELO_SERVIR_OVERVIEW = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.modeloServirOverview.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.modeloServirOverview.data.push(data)
      }
    })
  }
}
export const SET_MODELO_SERVIR_OVERVIEW_LOADING = (state, payload) => {
  state.modeloServirOverview.loading = payload
}

export const SET_MODELO_SERVIR_PRODUCTIVITY = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.modeloServirProductivity.data = payload
    state.modeloServirProductivity.lastUpdate = new Date()
  }
}
export const ADD_MODELO_SERVIR_PRODUCTIVITY = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.modeloServirProductivity.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.modeloServirProductivity.data.push(data)
      }
    })
  }
}
export const SET_MODELO_SERVIR_PRODUCTIVITY_LOADING = (state, payload) => {
  state.modeloServirProductivity.loading = payload
}

export const SET_MODELO_SERVIR_INDIVIDUAL = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.modeloServirIndividual.data = payload
    state.modeloServirIndividual.lastUpdate = new Date()
  }
}
export const ADD_MODELO_SERVIR_INDIVIDUAL = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.modeloServirIndividual.data.find(
        (item) => item.id === data.id
      )
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.modeloServirIndividual.data.push(data)
      }
    })
  }
}
export const SET_MODELO_SERVIR_INDIVIDUAL_LOADING = (state, payload) => {
  state.modeloServirIndividual.loading = payload
}

export const SET_FILTRO_MODELO_SERVIR = (state, payload) => {
  if (!Array.isArray(payload) || !payload.length) {
    state.filtroModeloServir = {}
    return
  }

  const startDate =
    payload && payload[0] && payload[0].data ? payload[0].data : null
  const endDate =
    payload && payload[1] && payload[1].data ? payload[1].data : null

  const anotherOptions = {}

  payload.slice(2, payload.length).forEach((item) => {
    if (!item || !item.options || !item.options.key) return
    anotherOptions[item.options.key] = item.data
  })

  state.filtroModeloServir = {
    startDate,
    endDate,
    ...anotherOptions,
    originalValue: payload,
  }
}
